/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentTemplateCategoryDto } from '../../models/document-template-category-dto';

export interface AdminDocumentTemplateCategoryControllerFindAll$Params {

/**
 * 센터 ID
 */
  centerId?: string;
}

export function adminDocumentTemplateCategoryControllerFindAll(http: HttpClient, rootUrl: string, params?: AdminDocumentTemplateCategoryControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentTemplateCategoryDto>>> {
  const rb = new RequestBuilder(rootUrl, adminDocumentTemplateCategoryControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentTemplateCategoryDto>>;
    })
  );
}

adminDocumentTemplateCategoryControllerFindAll.PATH = '/api/document-template-category-admin';
